import type { AppDispatch } from "store";
import {
  fetchProductListForWeb,
  type GetProductListParams,
} from "services/productService";
import {
  setProductWebLoading,
  setProductWebData,
  setProductWebError,
} from "./reducer";

// Thunk to call /product/getallproductsforweb (no auth/token required)
export const fetchProductListForWebThunk =
  (params: GetProductListParams) => async (dispatch: AppDispatch) => {
    dispatch(setProductWebLoading(true));
    dispatch(setProductWebError(null));
    try {
      const response = await fetchProductListForWeb(params);

      if (response.success && response.data) {
        dispatch(
          setProductWebData({
            products: response.data.product,
            pagination: response.data.pagination,
          })
        );
      } else {
        dispatch(
          setProductWebError(
            response.message || "Failed to fetch products for web"
          )
        );
      }
    } catch (error: any) {
      const message =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";
      dispatch(setProductWebError(message));
    } finally {
      dispatch(setProductWebLoading(false));
    }
  };

